module.exports = __webpack_public_path__ + "static/img/no_permission.5dbc6a1.png";